import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const POSTS = [
  {
    slug: "ritual-belleza-invernal",
    title: "Ritual de belleza invernal",
    excerpt: "Cómo proteger su piel del frío con los gestos de las grandes casas. Un protocolo en cuatro pasos firmado por nuestros expertos.",
    image: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=1600&q=85",
    category: "Belleza",
    date: "14 Febrero MMXXVI",
    readtime: "5 min",
  },
  {
    slug: "diamantes-historia",
    title: "Diamantes: la historia detrás del fuego",
    excerpt: "Del lecho del río Krishna a las vitrinas de la rue Cambon. Un viaje a través de las gemas más codiciadas del mundo.",
    image: "https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=1600&q=85",
    category: "Joyería",
    date: "8 Febrero MMXXVI",
    readtime: "7 min",
  },
  {
    slug: "peonias-temporada",
    title: "El arte efímero: peonías de temporada",
    excerpt: "Nuestra florista jefe nos descubre los secretos de las peonías Sarah Bernhardt y por qué cada flor es única.",
    image: "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=1600&q=85",
    category: "Floristería",
    date: "30 Enero MMXXVI",
    readtime: "4 min",
  },
  {
    slug: "perfume-firma",
    title: "Construir su perfume firma",
    excerpt: "El aroma como autorretrato. Cómo elegir y combinar fragancias para crear una identidad olfativa única.",
    image: "https://images.unsplash.com/photo-1774682060997-f8959850a7d4?w=1600&q=85",
    category: "Perfumería",
    date: "22 Enero MMXXVI",
    readtime: "6 min",
  },
];

export default function Blog() {
  return (
    <div data-testid="blog-page" className="pt-28 min-h-screen">
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="text-center mb-20">
          <p className="overline mb-4">Editorial</p>
          <h1 className="font-heading text-5xl md:text-7xl text-ivory font-light tracking-tighter">El Journal</h1>
          <p className="text-ivory/60 mt-6 max-w-xl mx-auto font-light leading-relaxed">
            Crónicas, entrevistas y lookbooks. La voz de la Maison.
          </p>
        </div>

        {/* Featured */}
        <motion.article
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-24 items-center"
        >
          <Link to={`/blog/${POSTS[0].slug}`} className="block aspect-[4/5] overflow-hidden bg-graphite group">
            <img src={POSTS[0].image} alt="" className="product-img w-full h-full object-cover" />
          </Link>
          <div>
            <p className="overline mb-3">{POSTS[0].category}</p>
            <h2 className="font-heading text-4xl md:text-5xl text-ivory font-light tracking-tighter leading-tight mb-6">{POSTS[0].title}</h2>
            <p className="text-ivory/70 text-lg leading-relaxed font-light mb-8">{POSTS[0].excerpt}</p>
            <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-ivory/50 mb-8">
              <span>{POSTS[0].date}</span>
              <span>·</span>
              <span>{POSTS[0].readtime}</span>
            </div>
            <Link to={`/blog/${POSTS[0].slug}`} className="btn-outline-gold inline-block">Leer artículo</Link>
          </div>
        </motion.article>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {POSTS.slice(1).map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              data-testid={`blog-post-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`} className="block group">
                <div className="aspect-[4/5] overflow-hidden bg-graphite mb-5">
                  <img src={p.image} alt="" className="product-img w-full h-full object-cover" />
                </div>
                <p className="overline mb-2">{p.category}</p>
                <h3 className="font-heading text-2xl text-ivory group-hover:text-gold transition-colors leading-tight mb-3">{p.title}</h3>
                <p className="text-ivory/60 text-sm font-light leading-relaxed">{p.excerpt}</p>
                <div className="flex gap-3 text-xs uppercase tracking-[0.2em] text-ivory/40 mt-4">
                  <span>{p.date}</span>
                  <span>·</span>
                  <span>{p.readtime}</span>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
